import { render } from "./AgentLeadQuoteForm.vue?vue&type=template&id=0f772d11&scoped=true&lang=pug"
import script from "./AgentLeadQuoteForm.vue?vue&type=script&lang=js"
export * from "./AgentLeadQuoteForm.vue?vue&type=script&lang=js"

import "./AgentLeadQuoteForm.vue?vue&type=style&index=0&id=0f772d11&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f772d11"]])

export default __exports__